import { BeetsStSAbi } from '../abis/beets'
import { TotalSupplyAbi } from '../abis/shared'
import type { LstRegistryEntry } from '../registry'
import { ONE_E18, toBigInt, type LstReader } from './shared'

/**
 * Beets stS (Sonic Staked Sonic) reader.
 *
 * Three calls:
 *   1. `stS.totalSupply()`
 *   2. `stS.getRate()` — 1e18-scaled S-per-stS rate
 *   3. `stS.totalPool()` — undelegated S buffer (instant-exit liquidity)
 *
 * Verified against `beethovenxfi/sonic-staking` source — `getRate()`
 * is the canonical share-price getter, `totalPool()` reflects how
 * much S can exit without going through the validator-unbond queue.
 */
export const readerBeetsStS = (entry: LstRegistryEntry): LstReader => ({
  calls: [
    { address: entry.address, name: 'totalSupply', params: [] },
    { address: entry.address, name: 'getRate', params: [] },
    { address: entry.address, name: 'totalPool', params: [] },
  ],
  abis: [TotalSupplyAbi, BeetsStSAbi, BeetsStSAbi],
  parse: ([supply, rate, pool]) => {
    const totalSupply = toBigInt(supply)
    const exchangeRate = toBigInt(rate)
    if (totalSupply === undefined || exchangeRate === undefined) {
      return undefined
    }
    const liquidity = toBigInt(pool)
    return {
      totalAssets: (totalSupply * exchangeRate) / ONE_E18,
      totalSupply,
      exchangeRate,
      liquidity,
    }
  },
})
